export interface ILoginResponse {
  token: string;
  refreshToken?: string | null;
}
